import { render, staticRenderFns } from "./twoPage.vue?vue&type=template&id=572e1675&"
import script from "./twoPage.vue?vue&type=script&lang=js&"
export * from "./twoPage.vue?vue&type=script&lang=js&"
import style0 from "./twoPage.vue?vue&type=style&index=0&id=572e1675&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports